module.exports = __webpack_public_path__ + "img/ileti_kalkan.ffa0fa8b.svg";